import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MatIconRegistry } from '@angular/material/icon';

import { FsOffline } from '@firestitch/offline';
import { FsProgressModule } from '@firestitch/progress';

import { AppService, WindowMessageService } from '@common/services';

import { ObjectDrawerService } from '@libs/drawers/drawer';

import { TimerService } from './time-entry';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FsProgressModule, RouterOutlet],
})
export class AppComponent {
  private _offline = inject(FsOffline);
  private _timerService = inject(TimerService);
  private _objectDrawerService = inject(ObjectDrawerService);
  private _windowMessageService = inject(WindowMessageService);
  private _appService = inject(AppService);
  private _iconRegistry = inject(MatIconRegistry);
  constructor() {
    this._timerService.init();
    this._appService.init();
    this._windowMessageService.init();
    this._offline.init();
    this._objectDrawerService.init();
    this._iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }

}
